/*-----------------------------------------------------------------
- MIXINS: Global
-----------------------------------------------------------------*/
export default {
    name: 'GlobalMixin',
};
